/**
 * @generated SignedSource<<653be591ec8bdbf9285780d96826e273>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AprStatus = "AVAILABLE" | "NOT_APPLICABLE" | "SOON" | "%future added value";
export type PerpsRiskLevel = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type PerpsPoolSubscription$variables = {
  id: string;
};
export type PerpsPoolSubscription$data = {
  readonly node: {
    readonly liquidity?: {
      readonly locked: {
        readonly amount: bigint;
        readonly valueUsd: bigint;
      };
      readonly total: {
        readonly amount: bigint;
        readonly valueUsd: bigint;
      };
      readonly unlocked: {
        readonly valueUsd: bigint;
      };
    };
    readonly stats?: {
      readonly lpApr: {
        readonly status: AprStatus;
        readonly value: bigint | null | undefined;
      };
      readonly lpRoi: {
        readonly status: AprStatus;
        readonly value: bigint | null | undefined;
      };
      readonly risk: PerpsRiskLevel;
      readonly sharpeRatio: bigint;
      readonly xlpApr: {
        readonly status: AprStatus;
        readonly value: bigint | null | undefined;
      };
      readonly xlpRoi: {
        readonly status: AprStatus;
        readonly value: bigint | null | undefined;
      };
    };
  } | null | undefined;
};
export type PerpsPoolSubscription = {
  response: PerpsPoolSubscription$data;
  variables: PerpsPoolSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueUsd",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  (v3/*: any*/)
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PerpsStats",
      "kind": "LinkedField",
      "name": "stats",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Apr",
          "kind": "LinkedField",
          "name": "lpApr",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Apr",
          "kind": "LinkedField",
          "name": "xlpApr",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Apr",
          "kind": "LinkedField",
          "name": "lpRoi",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Apr",
          "kind": "LinkedField",
          "name": "xlpRoi",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "risk",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sharpeRatio",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PerpsLiquidity",
      "kind": "LinkedField",
      "name": "liquidity",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Balance",
          "kind": "LinkedField",
          "name": "total",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Balance",
          "kind": "LinkedField",
          "name": "locked",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Balance",
          "kind": "LinkedField",
          "name": "unlocked",
          "plural": false,
          "selections": [
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PerpsPool",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PerpsPoolSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PerpsPoolSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "06c7c2e074782af8809db1a74fe98e9d",
    "id": null,
    "metadata": {},
    "name": "PerpsPoolSubscription",
    "operationKind": "subscription",
    "text": "subscription PerpsPoolSubscription(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on PerpsPool {\n      stats {\n        lpApr {\n          value\n          status\n        }\n        xlpApr {\n          value\n          status\n        }\n        lpRoi {\n          value\n          status\n        }\n        xlpRoi {\n          value\n          status\n        }\n        risk\n        sharpeRatio\n      }\n      liquidity {\n        total {\n          amount\n          valueUsd\n        }\n        locked {\n          amount\n          valueUsd\n        }\n        unlocked {\n          valueUsd\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d60a8004694862cb206ed4e24ad0e8bc";

export default node;
